import { Loader2, AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { SalesOrderStatus } from '../types/salesOrder.types';

interface Props {
  status: SalesOrderStatus;
  /** 86d3mnuxe — the outbox posting status for this SO ("Posting" in flight / "Failed" dead-lettered),
   *  if a posting job exists. Overrides the Draft entity status so the list shows the spinner / failed
   *  badge (the posting lifecycle moved off the entity). null/undefined → plain entity status. */
  postingStatus?: 'Posting' | 'Failed' | null;
  /** Optional failure reason (outbox LastError) — the badge tooltip on a failed post. */
  failedReason?: string | null;
}

// 86d3mnuxe — Submitted (entity) or Draft (entity), with the posting spinner / failed badge overlaid from
// the OUTBOX status when a posting.so job is in flight / dead-lettered for this Draft.
export function SalesOrderStatusBadge({ status, postingStatus, failedReason }: Props) {
  if (status === SalesOrderStatus.Submitted) {
    return <Badge className="bg-success/10 text-success hover:bg-success/10">Submitted</Badge>;
  }
  if (postingStatus === 'Posting') {
    return (
      <Badge className="gap-1 bg-info/10 text-info hover:bg-info/10">
        <Loader2 className="h-3 w-3 animate-spin" />
        Posting…
      </Badge>
    );
  }
  if (postingStatus === 'Failed') {
    return (
      <Badge
        className="gap-1 bg-destructive/10 text-destructive hover:bg-destructive/10"
        title={failedReason ?? 'Posting failed — open the order to retry'}
      >
        <AlertTriangle className="h-3 w-3" />
        Failed
      </Badge>
    );
  }
  return <Badge variant="secondary">Draft</Badge>;
}
